/**
 * SJGROW-3037
 * Converts all property values to strings for consistent GA4 analytics across all platforms
 * @param data - The data object to convert
 * @returns The data object with all values converted to strings
 */
const convertValuesToString = (data: any) => {
  if (data === null || data === undefined) {
    return data;
  }

  if (typeof data === 'object') {
    Object.keys(data).forEach((key: string) => {
      if (typeof data[key] === 'object' && data[key] !== null) {
        data[key] = convertValuesToString(data[key]);
      } else {
        data[key] = String(data[key]);
      }
    });
  }

  return data;
};

export default convertValuesToString;